import {TooltipContentProps} from '@radix-ui/react-tooltip';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as Tooltip from '@wandb/weave/components/RadixTooltip';
import React, {useState} from 'react';
import {twMerge} from 'tailwind-merge';

type NamedWorkspaceTooltipProps = {
  tooltipContent: string;
  tooltipWidth: string;
  dataTest: string;
  children: React.ReactNode;
  contentProps: TooltipContentProps;
};

/**
 * This uses the Radix Tooltip with Tailwind.
 * This is separate from the TagTooltip component (that uses Semantic Popup) because
 * styles class when we mix non-Tailwind with tailwind.
 */
export const NamedWorkspaceTooltip = ({
  contentProps,
  tooltipContent,
  tooltipWidth,
  dataTest,
  children,
}: NamedWorkspaceTooltipProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Tooltip.Root open={isOpen} onOpenChange={setIsOpen}>
      <Tooltip.Trigger data-test={dataTest}>{children}</Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content
          {...contentProps}
          className={twMerge(
            'night-aware z-[3] flex items-center p-12',
            'bg-moon-900 text-moon-200 dark:bg-moon-50 dark:text-moon-800'
          )}>
          <p className={`ml-8 w-[${tooltipWidth}] font-normal`}>
            {tooltipContent}
          </p>
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
};
